import React from 'react';
import PropTypes from 'prop-types';
import {
  FieldInputProps,
  FieldMetaProps,
} from '../../Constants/ReduxFormPropTypes';

const CardExpField = ({ input, meta, disabled }) => (
  <div className="col-auto d-flex flex-column">
    <label
      htmlFor={input.name}
      className={
        meta.touched && meta.error ? 'label form-error__label' : 'label'
      }
    >
      Expiration Date
    </label>
    {meta.touched && meta.error && (
      <div className="form-error mt-2 form-group--order-4">{meta.error}</div>
    )}
    <input
      {...input}
      id={input.name}
      className="form-control form-control-lg mw--130"
      aria-label="Credit Card expiration"
      placeholder="MM / YY"
      type="tel"
      disabled={disabled}
    />
  </div>
);
CardExpField.propTypes = {
  input: FieldInputProps.isRequired,
  meta: FieldMetaProps.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default CardExpField;
